<script>
    import FancyButton from './FancyButton.svelte';
</script>


<FancyButton label="Play Now!" image={"/worker.svg"}/>